const styles = {
  fab: (open: boolean) => ({
    boxShadow: "none",
    bgcolor: open ? "primary.main" : "white",
    color: open ? "white" : "primary.main",
    "&:hover": {
      bgcolor: open ? "primary.dark" : "white",
      boxShadow: "none"
    },
    "&:active": { boxShadow: "none" },
  }),
  fabIcon: (open: boolean) => ({
    fontSize: open ? 25 : 35,
  }),
  paper: (fullscreen: boolean, isDragged: boolean) => ({
    position: "fixed",
    top: 85,
    right: 10,
    width: fullscreen ? "35vw" : 360,
    height: fullscreen || !isDragged ? "90vh" : 600,
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    overflow: "hidden",
    zIndex: 1300,
  }),
  draggingPaper: {
    width: 360,
    height: 600,
  },
  header: {
    py: 1.5,
    px: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    bgcolor: "#f5f6fb",
    color: "#173662",
    borderBottom: "1px solid #17366222",
    cursor: "grab",
    "&:active": {
      cursor: "grabbing",
    },
  },
  dragIcon: {
    color: "#173662",
    transform: "rotate(90deg)"
  },
  fullscreenExitIcon: {
    color: "#173662"
  },
  fullscreenIcon: {
    color: "#173662"
  },
  closeButton: {
    color: "#173662"
  },
  messagesWrapper: {
    flex: 1,
    p: 2,
    overflowY: "auto",
    bgcolor: "#fefefe",
  },
  messagesInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    minHeight: "100%",
  },
  messageRowUser: {
    display: "flex",
    justifyContent: "flex-end",
    "&:hover .saveQueryBtn": {
      opacity: 1,
      pointerEvents: "auto",
    },
  },
  messageRowBot: {
    display: "flex",
    justifyContent: "flex-start",
    "&:hover .saveQueryBtn": {
      opacity: 1,
      pointerEvents: "auto",
   },
  },
  messageBubbleUser: {
    bgcolor: "#e7f1fe",
    color: "#173662",
    px: 2,
    py: 1,
    borderRadius: 2,
    maxWidth: "75%",
    whiteSpace: "pre-line",
  },
  messageBubbleBot: {
    bgcolor: "#f7f8fb",
    color: "#173662",
    px: 2,
    py: 1,
    borderRadius: 2,
    maxWidth: "75%",
    whiteSpace: "pre-line",
  },
  suggestedButton: {
    justifyContent: "flex-start",
    bgcolor: "white",
    color: "#173662",
    textTransform: "none",
    boxShadow: "0px 1px 3px rgba(0,0,0,0.12)",
    textAlign: "left",
    height: 'auto',
    lineHeight: 1.5,
    py: 1,
    px: 1.5,
  },
  inputWrapper: {
    display: "flex",
    p: 1,
    borderTop: "1px solid #ddd",
    bgcolor: "#fefefe",
    alignItems: "center",
  },
  inputField: {
    bgcolor: "white",
    borderRadius: 2,
    "& .MuiInputBase-root": {
      paddingLeft: "4px",
    },
    ".MuiInputBase-input": {
      fontSize: "14px",
    },
  },
  sendButton: {
    ml: 1,
  },
  blinkingIcon: {
    animation: "pulseGlow 1.2s infinite ease-in-out",
    "@keyframes pulseGlow": {
      "0%, 100%": { opacity: 1, transform: "scale(1)" },
      "50%": { opacity: 0.4, transform: "scale(1.2)" },
    },
  },
  saveQueryButton: {
    width: 'fit-content',
    height: 'fit-content',
    alignSelf: 'center',
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 0.2s ease",
    mx: 1,
  },
  saveQueryIcon: {
    fontSize: 22
  },
  savedQueryButton: {
    pointerEvents: 'none',
    cursor: 'default',
  },
  loadingQueryIcon: {
    fontSize: 10
  },
  savedQueryContainer: {
    bgcolor: "#ffffff",
    maxHeight: 300,
    overflowY: "auto",
    width: 350
  },
  savedQueryItemButton: {
    padding: 0,
    "&.MuiButtonBase-root.MuiListItemButton-root": {
      // color: "#173662",
      p: "2px 10px"
    },
    "&:hover.MuiButtonBase-root.MuiListItemButton-root": {
      bgcolor: "#ebedf5",
    },
  },
  savedQueryItemText: {
    "& .MuiTypography-root": {
      fontSize: '13px',
    }
  }
};

export default styles;
